module.exports = __webpack_public_path__ + "static/a-titan-raises-the-bar-social-banners-1200x630-15fa15f02b62d7f177ab53cf974eb4cc.jpg";